/*
Copied from https://github.com/draft-js-plugins/draft-js-plugins/tree/master/packages/mention
*/

import { MentionData } from '@draft-js-plugins/mention'
import { EditorState, Modifier } from 'draft-js'

import getSearchText from './getSearchText'
import getTypeByTrigger from './getTypeByTrigger'

export default function addMention(
  editorState: EditorState,
  mention: MentionData,
  mentionTrigger: string,
  entityMutability: 'SEGMENTED' | 'IMMUTABLE' | 'MUTABLE'
): EditorState {
  const contentStateWithEntity = editorState
    .getCurrentContent()
    .createEntity(getTypeByTrigger(mentionTrigger), entityMutability, {
      mention
    })
  const entityKey = contentStateWithEntity.getLastCreatedEntityKey()

  const mentionTextSelection = editorState.getSelection()

  let mentionReplacedContent = Modifier.replaceText(
    editorState.getCurrentContent(),
    mentionTextSelection,
    mention.name,
    undefined, // no inline style needed
    entityKey
  )

  // If the mention is inserted at the end, a space is appended right after for
  // a smooth writing experience.
  const blockKey = mentionTextSelection.getAnchorKey()
  const blockSize = editorState.getCurrentContent().getBlockForKey(blockKey).getLength()

  const { end } = getSearchText(editorState, mentionTextSelection, [mentionTrigger])
  if (blockSize === end) {
    mentionReplacedContent = Modifier.insertText(
      mentionReplacedContent,
      mentionReplacedContent.getSelectionAfter(),
      ' '
    )
  }

  const newEditorState = EditorState.push(editorState, mentionReplacedContent, 'insert-fragment')
  return EditorState.forceSelection(newEditorState, mentionReplacedContent.getSelectionAfter())
}
